<template>
    <div class="controls">
        <div
            class="left"
            :class="{ disabled: !hasPrev }"
            @click="$emit('prev')"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.80864 12L18.1586 21.0735C18.7747 21.743 18.7747 22.8284 18.1586 23.4979C17.5426 24.1674 16.5437 24.1674 15.9276 23.4979L6.46207 13.2122C5.84598 12.5427 5.84598 11.4573 6.46207 10.7878L15.9276 0.502102C16.5437 -0.167368 17.5426 -0.167368 18.1586 0.502102C18.7747 1.17157 18.7747 2.257 18.1586 2.92647L9.80864 12Z"/>
            </svg>

        </div>
        <div class="label">
            {{ monthLabel(0) }}
            {{ startOfInterval.year() }}
            &nbsp;—&nbsp;
            {{ monthLabel(this.monthsToShow) }}
            {{ endOfInterval.year() }}
        </div>
        <div
            class="right"
            :class="{ disabled: !hasNext }"
            @click="$emit('next')"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.1914 12L5.84135 2.92647C5.22526 2.257 5.22526 1.17157 5.84135 0.502103C6.45744 -0.167368 7.45631 -0.167368 8.0724 0.502103L17.5379 10.7878C18.154 11.4573 18.154 12.5427 17.5379 13.2122L8.0724 23.4979C7.45631 24.1674 6.45744 24.1674 5.84135 23.4979C5.22526 22.8284 5.22526 21.743 5.84135 21.0735L14.1914 12Z"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimelineControlsDesktop',
    props: {
        startOfInterval: {
            type: Object,
            required: true,
        },
        monthsToShow: {
            type: Number,
            required: true,
        },
        hasPrev: {
            type: Boolean,
            required: true,
        },
        hasNext: {
            type: Boolean,
            required: true,
        },
    },
    data: () => ({
        months: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ],
    }),
    computed: {
        endOfInterval() {
            return this.startOfInterval
                .clone()
                .add(this.monthsToShow + 1, 'months');
        },
        monthLabel() {
            return (i) => {
                return this.months[(this.startOfInterval.month() + i) % 12];
            };
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .controls {
        user-select: none;
        display: flex;
        width: 300px;
        justify-content: space-between;
        align-items: flex-start;

        .label {
            font-size: 16px;
            line-height: 24px;
            text-transform: lowercase;
        }

        .left,
        .right {
            min-width: 24px;
            min-height: 24px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            cursor: pointer;

            &.disabled {
                cursor: default;
                opacity: .2;
            }
        }
        .left,
        .right {
            svg,
            &.disabled:hover svg {
                fill: #D2D5D9;
            }
            &:hover svg {
                fill: #4663AB;
            }
        }
    }
</style>
